/* eslint-disable*/
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Typography, Button } from '@material-ui/core';
// import useStyles from '../../Main/Main.style';
// import useCommunityList from '../../../../hooks/useCommunityList';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import useCommunityList from '../../../hooks/useCommunityList';
import useLogin from '../../../../src/hooks/useAuth';

const DialogTitle = (props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className="" {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className="CloseButton" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const ModalRemoveVideo = (props) => {
  const key = 'iFrasCwdJh';
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const { getRoleData } = useLogin();
  const [userData, setUserData] = useState();

  const [userId] = useState(loggedInUserData?.id);

  const getUserData = async () => {
    const userDataResult = await getRoleData({ userId });
    setUserData(userDataResult.usersResult);
    console.log(userDataResult, 'GET');
    return userDataResult;
  };

  console.log(userData?.emailId, 'UDM');

  useEffect((newValue) => {
    if (userCookie) {
      getUserData();
    }
  }, []);

  const navigate = useNavigate();
  const { deleteVideoRequest } = useCommunityList();

  const { videoId, fetchVideoData, onDeleteUploadSuccess } = props; // Access the videoId from the props

  // Log the videoId to the console
  console.log('videoId1:', videoId);

  const [open, setOpen] = React.useState(props.status);

  const handleRemoveVideo = async () => {
    // Call the deleteVideoRequest hook with the videoId

    try {
      const response = await deleteVideoRequest({ videoId, communityRepEmail: userData?.emailId });
      if (response.status === true) {
        onDeleteUploadSuccess();
        handleClose(); // Close the modal
        props.handleCloseEdit();
        fetchVideoData();
      }
    } catch (error) {
      // Handle errors
      console.log(error);
    }
  };

  console.log(open, 'OPEN');
  const handleClose = () => {
    setOpen(false);
    props.onClose(false);
  };

  useEffect(() => {}, []);
  return (
    <>
      {/* Start Delete any changes Modal */}
      <Dialog
        className="DeleteDialog"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <MuiDialogTitle
          className="DialogTitleLeft"
          id="customized-dialog-title"
          onClose={handleClose}
        >
          <Typography variant="h4" component="div" className="DialogTitleHeading TextColor">
            Are you sure you want to remove your video?
          </Typography>
          <CloseIcon onClick={handleClose} />
        </MuiDialogTitle>
        <MuiDialogContent>
          <Typography gutterBottom variant="body2" component="div">
            This action is permanent. If you proceed, this video cannot be recovered by Move to
            Happy.
          </Typography>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            className="NoBorderButton"
          >
            No, Go Back
          </Button>
          <Button
            color="secondary"
            variant="contained"
            className="NowrapButton"
            onClick={handleRemoveVideo}
          >
            YES, Remove Video
          </Button>
        </MuiDialogActions>
      </Dialog>
      {/* End Delete any changes Modal */}
    </>
  );
};
ModalRemoveVideo.defaultProps = {};
export default ModalRemoveVideo;
